import React, { Component } from "react";
import PropTypes from "prop-types";

import Checkbox from "../../controls/CheckMark.jsx";
import InputError from "../../controls/InputError.jsx";

import PasswordValidationSettings from "../../entities/PasswordValidationSettings";
import PasswordValidationUserData from "../../entities/PasswordValidationUserData";
import { evaluateRules } from "../../utilities/PasswordValidation";
import ServerError from "../common/ServerError";
import { isEnterPressed } from "newApp/utilities/EventsHelper";

class ChangePasswordComponent extends Component {
    constructor (props) {
        super(props);

        this.state = {
            newPassword: "",
            newPasswordConfirm: "",
            currentPassword: "",
            passwordValidationRules: props.passwordValidationRules,
            allowConfirmPassword: false,
            passwordsMatch: false,
            showPasswordMatchError: false,
            allowChangePassword: false
        };

        this.handleEnterKey = this.handleEnterKey.bind(this);
        this.handleEnterNewPassword = this.handleEnterNewPassword.bind(this);
        this.handleEnterCurrentPassword = this.handleEnterCurrentPassword.bind(this);
        this.handleSaveButtonClick = this.handleSaveButtonClick.bind(this);
        this.handleChangeConfirmationPassword = this.handleChangeConfirmationPassword.bind(this);
        this.handleConfirmationPasswordEntered = this.handleConfirmationPasswordEntered.bind(this);
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.props.onSave(this.state.currentPassword, this.state.newPassword);
        }
    }

    handleEnterNewPassword (input) {
        const newPasswordValue = input.target.value;
        var result = evaluateRules(this.state.passwordValidationRules, newPasswordValue, this.state.newPasswordConfirm, this.state.currentPassword, this.props.passwordValidationUserData);
        this.setState({ showPasswordMatchError: false, newPassword: newPasswordValue, allowConfirmPassword: result.allowConfirmPassword, passwordsMatch: result.passwordsMatch, allowChangePassword: result.allowChangePassword });
    }

    handleEnterCurrentPassword (input) {
        const currentPasswordValue = input.target.value;
        var result = evaluateRules(this.state.passwordValidationRules, this.state.newPassword, this.state.newPasswordConfirm, this.state.currentPassword, this.props.passwordValidationUserData);
        this.setState({ currentPassword: currentPasswordValue, allowConfirmPassword: result.allowConfirmPassword, passwordsMatch: result.passwordsMatch, allowChangePassword: result.allowChangePassword });
    }

    handleSaveButtonClick () {
        this.props.onSave(this.state.newPassword, this.state.currentPassword);
    }

    handleConfirmationPasswordEntered () {
        var result = evaluateRules(this.state.passwordValidationRules, this.state.newPassword, this.state.newPasswordConfirm, this.state.currentPassword, this.props.passwordValidationUserData);
        this.setState({ showPasswordMatchError: true, allowConfirmPassword: result.allowConfirmPassword, passwordsMatch: result.passwordsMatch, allowChangePassword: result.allowChangePassword });
    }

    handleChangeConfirmationPassword (input) {
        const confirmedPassword = input.target.value;
        var result = evaluateRules(this.state.passwordValidationRules, this.state.newPassword, confirmedPassword, this.state.currentPassword, this.props.passwordValidationUserData);
        this.setState({ newPasswordConfirm: confirmedPassword, allowConfirmPassword: result.allowConfirmPassword, passwordsMatch: result.passwordsMatch, allowChangePassword: result.allowChangePassword });
    }

    render () {
        const errorSummary = this.props.errorSummary || "Error";

        return (<div>
            <div className="box">
                <div className="row">
                    <div className="formControlTitle">Current Password</div>
                    <input id="currentPassword" tabIndex="1" autoFocus={true}
                        onChange={this.handleEnterCurrentPassword}
                        className="password picker-hollow" type="password"/>

                </div>
                <div className="row">
                    <div className="formControlTitle" id="helpMessage">Please enter a new password that:</div>
                    {renderCheckboxes(this.state.passwordValidationRules)}
                </div>

                <div className="row">
                    <div className="formControlTitle">New Password</div>
                    <input id="newPassword" tabIndex="1"
                        className="password picker-hollow" onChange={this.handleEnterNewPassword}
                        type="password"/>

                </div>
                <div className="row">
                    <div className="formControlTitle">Confirm New Password</div>
                    <input id="newPasswordConfirm" tabIndex="1"
                        disabled={!this.state.allowConfirmPassword} onKeyUp={this.handleEnterKey}
                        value={this.state.newPasswordConfirm}
                        className="password picker-hollow" onChange={this.handleChangeConfirmationPassword}
                        onBlur={this.handleConfirmationPasswordEntered}
                        type="password"/>
                </div>
                <div id="errPasswordsMismatch" className="row">
                    <InputError label="Passwords don't match" visible={!this.state.passwordsMatch && this.state.showPasswordMatchError}/>
                </div>


                <div className="row">
                    <button id="bChangePassword" className="btn-primary btn pull-right"
                        disabled={!this.state.allowChangePassword} onClick={this.handleSaveButtonClick} tabIndex="4">Save
                    </button>

                </div>

                <ServerError
                    id="alertSummary"
                    errorSummary={errorSummary}
                    serverError={this.props.serverFailureMessage}
                    isVisible={this.props.serverFailureMessage != null}/>
            </div>
        </div>);
    }
}

const buildRuleText = (rule, digits) => {
    return " " + rule + (digits === 1 ? " character" : " characters");
};

const renderCheckboxes = (passwordValidationRules) => {

    if (!passwordValidationRules || passwordValidationRules == {} || passwordValidationRules == null)
        return;
    //' special characters'
    var lengthLabel = 'is at least ' + passwordValidationRules.length.digits + ' characters long';
    var upperLabel = 'contains ' + passwordValidationRules.upperChars.digits + buildRuleText("uppercase", passwordValidationRules.upperChars.digits);
    var lowerLabel = 'contains ' + passwordValidationRules.lowerChars.digits + buildRuleText("lowercase", passwordValidationRules.lowerChars.digits);
    var numbersLabel = 'contains ' + passwordValidationRules.numbers.digits + buildRuleText("numeric", passwordValidationRules.numbers.digits);
    var specialLabel = 'contains ' + passwordValidationRules.special.digits + buildRuleText("special", passwordValidationRules.special.digits);
    var alphaLabel = 'contains ' + passwordValidationRules.alpha.digits + (passwordValidationRules.alpha.digits == 1 ? ' letter' : ' letters');
    var consecutiveCharsLabel = 'contains ' + passwordValidationRules.maxConsecutiveChars.digits + " or fewer" + buildRuleText("consecutive name/email", passwordValidationRules.maxConsecutiveChars.digits);

    return (<div style={{ "marginLeft": "50px" }}>
        <div id="vrLength">
            <Checkbox visible={passwordValidationRules.length.enabled}
                isChecked={passwordValidationRules.length.passed}
                label={lengthLabel}/>
        </div>
        <div id="vrAlpha">
            <Checkbox visible={passwordValidationRules.alpha.enabled}
                isChecked={passwordValidationRules.alpha.passed}
                label={alphaLabel}/>
        </div>
        <div id="vrUpperChars">
            <Checkbox visible={passwordValidationRules.upperChars.enabled}
                isChecked={passwordValidationRules.upperChars.passed}
                label={upperLabel}/>
        </div>
        <div id="vrLowerChars">
            <Checkbox visible={passwordValidationRules.lowerChars.enabled}
                isChecked={passwordValidationRules.lowerChars.passed}
                label={lowerLabel}/>
        </div>
        <div id="vrNumbers">
            <Checkbox visible={passwordValidationRules.numbers.enabled}
                isChecked={passwordValidationRules.numbers.passed}
                label={numbersLabel}/>
        </div>
        <div id="vrSpecial">
            <Checkbox visible={passwordValidationRules.special.enabled}
                isChecked={passwordValidationRules.special.passed}
                label={specialLabel}/>
        </div>
        <div id="vrConsecutiveChars">
            <Checkbox visible={passwordValidationRules.maxConsecutiveChars.enabled}
                isChecked={passwordValidationRules.maxConsecutiveChars.passed}
                label={consecutiveCharsLabel}/>
        </div>
    </div>);
};

ChangePasswordComponent.propTypes = {
    errorSummary:PropTypes.string,
    serverFailureMessage:PropTypes.string,
    passwordValidationUserData:PropTypes.instanceOf(PasswordValidationUserData),
    passwordValidationRules: PropTypes.instanceOf(PasswordValidationSettings).isRequired,
    onSave: PropTypes.func.isRequired
};

export default ChangePasswordComponent;
